import { c as _c } from "react/compiler-runtime";
import { useProjectTeamMenuOptionsMobile } from "@pages/project-details/project-team/use-project-team-menu-options-mobile";
import { MemberMobileList } from "@components/common/mobile/member-mobile-list";
/**
 * Mobile-specific view for members list.
 * Renders a virtualized list of members for the groups with selection, menu options, and bulk actions.
 */
export function ProjectTeamMobileView(t0) {
  const $ = _c(9);
  const {
    members,
    bulkActionButtons,
    isLoading,
    selectedProject,
    sortBy
  } = t0;
  let t1;
  if ($[0] !== selectedProject) {
    t1 = {
      selectedProject
    };
    $[0] = selectedProject;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const menuItems = useProjectTeamMenuOptionsMobile(t1);
  let t2;
  if ($[2] !== bulkActionButtons || $[3] !== isLoading || $[4] !== members || $[5] !== menuItems || $[6] !== selectedProject || $[7] !== sortBy) {
    t2 = <MemberMobileList members={members} isLoading={isLoading} bulkActionButtons={bulkActionButtons} tableSubject="project" menuItems={menuItems} selectedProject={selectedProject} sortBy={sortBy} />;
    $[2] = bulkActionButtons;
    $[3] = isLoading;
    $[4] = members;
    $[5] = menuItems;
    $[6] = selectedProject;
    $[7] = sortBy;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}